declare namespace $ {

	type $shm_textarea_code_rows__render_visible_only_shm_textarea_code_view_1 = $mol_type_enforce<
		ReturnType< $shm_textarea_code_view['render_visible_only'] >
		,
		ReturnType< $shm_textarea_code_rows['render_visible_only'] >
	>
	type $shm_textarea_code_rows__rows_shm_textarea_code_view_2 = $mol_type_enforce<
		ReturnType< $shm_textarea_code_view['rows'] >
		,
		ReturnType< $shm_textarea_code_rows['rows'] >
	>
	type $shm_textarea_code_line__numb_showed_shm_textarea_code_view_3 = $mol_type_enforce<
		ReturnType< $shm_textarea_code_view['sidebar_showed'] >
		,
		ReturnType< $shm_textarea_code_line['numb_showed'] >
	>
	type $shm_textarea_code_line__numb_shm_textarea_code_view_4 = $mol_type_enforce<
		ReturnType< $shm_textarea_code_view['row_numb'] >
		,
		ReturnType< $shm_textarea_code_line['numb'] >
	>
	type $shm_textarea_code_line__theme_shm_textarea_code_view_5 = $mol_type_enforce<
		ReturnType< $shm_textarea_code_view['row_theme'] >
		,
		ReturnType< $shm_textarea_code_line['theme'] >
	>
	type $shm_textarea_code_line__text_shm_textarea_code_view_6 = $mol_type_enforce<
		ReturnType< $shm_textarea_code_view['row_text'] >
		,
		ReturnType< $shm_textarea_code_line['text'] >
	>
	type $shm_textarea_code_line__syntax_shm_textarea_code_view_7 = $mol_type_enforce<
		ReturnType< $shm_textarea_code_view['syntax'] >
		,
		ReturnType< $shm_textarea_code_line['syntax'] >
	>
	type $shm_textarea_code_line__uri_resolve_shm_textarea_code_view_8 = $mol_type_enforce<
		ReturnType< $shm_textarea_code_view['uri_resolve'] >
		,
		ReturnType< $shm_textarea_code_line['uri_resolve'] >
	>
	type $shm_textarea_code_line__highlight_shm_textarea_code_view_9 = $mol_type_enforce<
		ReturnType< $shm_textarea_code_view['highlight'] >
		,
		ReturnType< $shm_textarea_code_line['highlight'] >
	>
	export class $shm_textarea_code_view extends $mol_text_code {
		render_visible_only( ): boolean
		Rows( ): $shm_textarea_code_rows
		Row( id: any): $shm_textarea_code_line
	}
	
}

//# sourceMappingURL=view.view.tree.d.ts.map